;
;
export function action(type, payload) {
    return {
        type: type,
        payload: payload,
    };
}
export function actionFetchStart(type) {
    return {
        type: type,
        payload: {
            meta: "fetching",
        }
    };
}
export function actionFetchSuccess(type, payload) {
    return {
        type: type,
        payload: {
            meta: "success",
            data: payload,
        }
    };
}
export function actionFetchFailure(type, error) {
    return {
        type: type,
        payload: {
            meta: "failure",
            data: error,
        }
    };
}
//# sourceMappingURL=Types.js.map